import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import StyledTreeItem from "./StylesMenuItem";
import MenuDesignerContext from "../../../../ContextComponents/MenuDesignerContext";

const TreeRender = ({menu, arrayPath, onOpen, level = 0, screenName, subRef = false}) => {
    const {selectItem} = useContext(MenuDesignerContext);
    return (
        menu.map((menuItem, index) => {
            const itemProperties = menuItem.properties ? menuItem.properties : menuItem;
            const hasChildren = Boolean(menuItem.sub);
            const path = !arrayPath ? `${index}` : `${arrayPath}.sub.${index}`;
            if (hasChildren) {
                return (
                    <StyledTreeItem
                        nodeId={path}
                        key={path}
                        labelText={itemProperties.label}
                        labelIcon={itemProperties.icon}
                        iconType={itemProperties.iconType}
                        badge={itemProperties.badge}
                        level={level}
                        subRef={subRef}
                        styles={menuItem.styles}
                        events={menuItem.events}
                        screenName={screenName}
                        onContextMenu={(e) => {
                            e.stopPropagation();
                            selectItem(path);
                            onOpen(e, path, !arrayPath ? '' : `${arrayPath}.sub`, index)
                        }}
                    >
                        {TreeRender({
                            menu: menuItem.sub,
                            arrayPath: path,
                            selectItem, onOpen,
                            level: level + 1,
                            screenName,
                            subRef: itemProperties.subRef || subRef
                        })}
                    </StyledTreeItem>
                )
            }
            return (
                <StyledTreeItem
                    nodeId={path}
                    key={path}
                    labelText={itemProperties.label}
                    labelIcon={itemProperties.icon}
                    iconType={itemProperties.iconType}
                    badge={itemProperties.badge}
                    styles={menuItem.styles}
                    events={menuItem.events}
                    screenName={screenName}
                    subRef={subRef}
                    level={level}
                    onContextMenu={(e) => {
                        e.stopPropagation();
                        selectItem(path);
                        onOpen(e, path, !arrayPath ? '' : `${arrayPath}.sub`, index)

                    }}
                />
            )
        })
    )
};

export default TreeRender

TreeRender.propTypes = {
    menu: PropTypes.array.isRequired,
    selectItem: PropTypes.func.isRequired,
    arrayPath: PropTypes.string
};